// /api  获取检测项目
<template>
	<div class="form-model-main">
		<div class="add-page-content">
			<div class="title">{{pageTitle}}</div>
			<div class="content">
				<a-form-model
						ref="ruleForm"
						:model="formData"
						:rules="rules"
						:label-col="labelCol"
						:wrapper-col="wrapperCol">
					<a-form-model-item ref="module" label="提醒模块" prop="module" :help="helpTip(formData.module)">
						<a-select
								placeholder="请选择需要体现的模块"
								v-model="formData.module"
						>
							<a-select-option
									v-for="item in moduleItems"
									:key="item.key"
									:value="item.key"
							>{{item.value}}
							</a-select-option>
						</a-select>
					</a-form-model-item>
					<a-form-model-item ref="status" prop="status" label="提醒状态">
						<a-select
								style="width:100%;"
								v-model="formData.status"
								placeholder="请选择提醒状态"
						>
							<a-select-option
									v-for="item in statusItems"
									:key="item.key"
									:value="item.key"
							>{{item.value}}
							</a-select-option>
						</a-select>
					</a-form-model-item>
					<a-form-model-item ref="hours" label="提醒时长" prop="hours" :help="helpTipHours(formData.module)">
						<a-input v-model="formData.hours" placeholder="请输入提醒时长"/>
					</a-form-model-item>
				</a-form-model>
				<div class="confrim-footer">
					<a-button @click="submitClick" type="primary" class="cf-mr10">确定</a-button>
					<a-button @click="cancelSubmit">取消</a-button>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
  export default {
    props: {
      dataRow: {
        type: Object,
        default: () => {
        }
      },
    },
    data() {
      return {
        labelCol: {span: 24},
        wrapperCol: {span: 24},
        data: [],
        helpModule: undefined,
        rules: {
          module: {required: true, message: '请选择提醒模块', trigger: 'blur'},
          status: {required: true, message: '请选择提醒状态', trigger: 'blur'},
          hours: {required: true, message: '请输入提醒时长', trigger: 'blur'},
        },
        moduleItems: [],
        statusItems: [],
        formData: {
          module: undefined,
          status: undefined,
          hours: undefined,
          preconditions: undefined,
          timeAlgorithm: undefined,
        },
        pageTitle: "添加预警设置",
        isSubmit: false,

      };
    },
    components: {},
    mounted() {
      if (this.dataRow && this.dataRow.id) {
        // this.formData = this.dataRow;
        this.pageTitle = '编辑预警设置';
        this.formData.id = this.dataRow.id;
        this.formData.warningId = this.dataRow.id;
        this.formData.module = this.dataRow.module;
        this.formData.status = this.dataRow.status;
        this.formData.hours = this.dataRow.hours;
      }
      this.getModuleData();
      this.getStatusData();
    },
    methods: {
      helpTip(module) {
        let tip = undefined;
        switch (module) {
          case 'JOB':
            tip = "作业运行中";
            break;
          case 'ITEM':
            tip = "就诊流程中两个fq未上传成功";
            break;
          case 'REPORT':
            tip = "报告管理中解读报告未上传";
            break;
          case 'PATIENT':
            tip = "患者管理中出生日期、疾病类型、患者组未录入";
            break;
        }
        this.formData.preconditions = tip;
        return tip;

      },
      helpTipHours(module) {
        let tip = undefined;
        switch (module) {
          case 'JOB':
            tip = "当前时间减作业开始时间";
            break;
          case 'ITEM':
            tip = "当前时间减采样日期（无采样日期的用录入时间）";
            break;
          case 'REPORT':
            tip = "当前时间减采样日期（无采样日期的用录入时间）";
            break;
          case 'PATIENT':
            tip = "当前时间减录入时间";
            break;
        }
        this.formData.timeAlgorithm = tip;
        return tip;
      },
      getModuleData() {
        this.$get("allconfig/warning/modules").then(res => {
          this.moduleItems = res.data.data;
        });
      },
      getStatusData() {
        this.$get("allconfig/warning/status").then(res => {
          this.statusItems = res.data.data;
        });
      },
      checkInput() {
        this.$get('/allconfig/warning/validate', this.formData).then(res => {
          if (res.data.code == 1) {
            this.saveData();
          } else {
            this.$message.error(res.data.message);
          }
        })
      },
      submitClick() {
        this.$refs.ruleForm.validate(valid => {
          if (!valid) {
            return false;
          }
          this.checkInput();
        })
      },
      saveData() {
        this.$post('/allconfig/warning', this.formData, {
          "Content-Type": "application/json"
        }).then(res => {
          if (res.data.code == 1) {
            this.$message.success("保存成功！");
            this.$emit("close");
          } else {
            this.$message.error(res.data.message);
          }
        })
      },
      cancelSubmit() {
        this.$emit("close");
      }
    }
  };
</script>

<style lang="scss" scoped>
</style>